import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useRetailSales = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.retailSales, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getRetailSales(), {
        params,
      });

      const composeResponse = {
        clinics: res.data.data.clinics,
        clinicRetailSales: res.data.data.clinic_retail_sales,
        providerRetailSales: res.data.data.provider_retail_sales,
      };
      return composeResponse;
    },
    options,
  );
};
